import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQueries } from '../../../../../../helpers/hooks';
import ResponsiveWebstoreModal from '../../ResponsiveWebstoreModal';
import AppStack from '../../../../../common/AppStack';
import AppText from '../../../../../common/AppText';

const WsFinalSaleWarningInfoModal = ({ isOpen, onClose }) => {
  const { isTabletOrSmaller } = useMediaQueries();
  return (
    <ResponsiveWebstoreModal
      alignModal={isTabletOrSmaller ? 'end' : 'center'}
      isOpen={isOpen}
      onClose={onClose}
      radius={0}
      size={600}
      title="Final sale policy"
      trapFocus={false}
      zIndex={201}
    >
      <AppStack style={{ gap: 16 }}>
        <AppText style={{ fontSize: 16 }}>
          Items marked as Final Sale are not eligible for cancellation, return,
          exchange, or refund for any reason, except in the case of a
          manufacturing defect.
        </AppText>

        <AppText style={{ fontSize: 16 }}>
          If an item is final sale, this status will be clearly shown before
          purchase on the product page and during checkout. By completing your
          order, you acknowledge and agree to these terms.
        </AppText>
      </AppStack>
    </ResponsiveWebstoreModal>
  );
};

WsFinalSaleWarningInfoModal.propTypes = {
  editModeEnabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onClose: PropTypes.func
};

export default WsFinalSaleWarningInfoModal;
